/**
 * VALEN VARET · Campaña Halloween (banner + sorteo)
 * ---------------------------------------------------------------
 * - Un único temporizador global (no se acumulan intervalos al
 *   recargar secciones en el editor).
 * - Hora de referencia = hora del SERVIDOR de Shopify (cabecera Date),
 *   no la del dispositivo. Si el reloj del visitante está mal, el
 *   contador sigue siendo correcto. La admisión real la decide el
 *   servidor del registro, nunca este archivo.
 * - "Termina hoy" se calcula con el calendario de Europe/Madrid,
 *   independiente de la zona horaria del dispositivo.
 * - Sin dependencias, sin datos personales en URLs, sin terceros.
 */
(function () {
  'use strict';
  if (window.VVHW) return; // evita doble registro

  var TZ = 'Europe/Madrid';
  var offset = 0; // serverNow - deviceNow (ms)
  var subscribers = new Set();
  var timer = null;

  function now() { return Date.now() + offset; }

  function syncServerTime() {
    try {
      var t0 = Date.now();
      return fetch('/cart.js?_vvt=' + t0, { method: 'GET', cache: 'no-store', credentials: 'same-origin' })
        .then(function (r) {
          var d = r.headers.get('Date');
          if (!d) return;
          var server = new Date(d).getTime();
          var rtt = Date.now() - t0;
          if (!isNaN(server)) offset = server + rtt / 2 - Date.now();
          tick();
        })
        .catch(function () { /* se usa el reloj del dispositivo como último recurso */ });
    } catch (e) { return Promise.resolve(); }
  }

  var dayFmt;
  try { dayFmt = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }); } catch (e) { dayFmt = null; }
  function madridDay(ms) { return dayFmt ? dayFmt.format(new Date(ms)) : new Date(ms).toISOString().slice(0, 10); }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function parts(ms) {
    var s = Math.max(0, Math.floor(ms / 1000));
    return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  }

  /** Estado de campaña a partir de instantes inequívocos (epoch ms). end es EXCLUSIVO. */
  function state(start, end, t) {
    if (!end || isNaN(end)) return 'invalid';
    if (start && t < start) return 'upcoming';
    if (t >= end) return 'closed';
    return 'active';
  }

  function tick() {
    var t = now();
    subscribers.forEach(function (fn) { try { fn(t); } catch (e) { /* un componente roto no rompe los demás */ } });
  }
  function subscribe(fn) {
    subscribers.add(fn);
    if (!timer) timer = setInterval(tick, 1000);
    fn(now());
  }
  function unsubscribe(fn) {
    subscribers.delete(fn);
    if (!subscribers.size && timer) { clearInterval(timer); timer = null; }
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) syncServerTime(); });

  /* ---------------- Cuenta atrás ---------------- */
  class VVHWCountdown extends HTMLElement {
    connectedCallback() {
      this.start = Date.parse(this.dataset.start || '') || 0;
      this.end = Date.parse(this.dataset.end || '');
      this.variant = this.dataset.variant || 'boxes';
      this.root = this.closest('[data-vvhw-root]') || this;
      this.last = '';
      this._fn = this.render.bind(this);
      subscribe(this._fn);
    }
    disconnectedCallback() { unsubscribe(this._fn); }
    render(t) {
      var st = state(this.start, this.end, t);
      if (this.root.getAttribute('data-state') !== st) {
        this.root.setAttribute('data-state', st);
        this.root.dispatchEvent(new CustomEvent('vvhw:state', { bubbles: true, detail: { state: st } }));
      }
      var target = st === 'upcoming' ? this.start : this.end;
      var p = parts(st === 'closed' ? 0 : target - t);
      var q = this.querySelector.bind(this);
      if (this.variant === 'compact') {
        var lastDay = st === 'active' && madridDay(t) === madridDay(this.end - 1);
        var label = st === 'upcoming' ? (this.dataset.labelUpcoming || 'Empieza en')
          : st === 'closed' ? (this.dataset.labelClosed || 'Finalizada')
          : lastDay ? (this.dataset.labelToday || 'Termina hoy') : (this.dataset.labelActive || 'Finaliza en');
        var ends = q('[data-hw-label]'); if (ends && ends.textContent !== label) ends.textContent = label;
        var dd = q('[data-hw="d"]');
        if (dd) { dd.textContent = p.d + 'd'; dd.hidden = p.d === 0; var sep = dd.nextElementSibling; if (sep) sep.hidden = p.d === 0; }
        set(q('[data-hw="h"]'), pad(p.h)); set(q('[data-hw="m"]'), pad(p.m)); set(q('[data-hw="s"]'), pad(p.s));
      } else {
        set(q('[data-c="d"]'), pad(p.d)); set(q('[data-c="h"]'), pad(p.h)); set(q('[data-c="m"]'), pad(p.m)); set(q('[data-c="s"]'), pad(p.s));
      }
    }
  }
  function set(el, v) { if (el && el.textContent !== v) el.textContent = v; }
  if (!customElements.get('vv-hw-countdown')) customElements.define('vv-hw-countdown', VVHWCountdown);

  /* ---------------- Formulario del sorteo ---------------- */
  class VVSorteoForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.msg = this.querySelector('[data-vvs-msg]');
      this.btn = this.querySelector('button[type="submit"]');
      this.endpoint = this.dataset.endpoint || '';
      this.enabled = this.dataset.enabled === 'true';
      this.end = Date.parse(this.dataset.end || '');
      this.start = Date.parse(this.dataset.start || '') || 0;
      if (!this.form) return;
      this._submit = this.onSubmit.bind(this);
      this.form.addEventListener('submit', this._submit);
      this._fn = this.watch.bind(this);
      subscribe(this._fn);
    }
    disconnectedCallback() {
      if (this.form) this.form.removeEventListener('submit', this._submit);
      if (this._fn) unsubscribe(this._fn);
    }
    watch(t) {
      var st = state(this.start, this.end, t);
      if (st === this.st) return;
      this.st = st;
      var off = !this.enabled || st !== 'active';
      this.form.toggleAttribute('data-closed', st === 'closed');
      Array.prototype.forEach.call(this.form.elements, function (el) { if (el.type !== 'hidden') el.disabled = off; });
      if (!this.enabled) this.show('info', this.dataset.msgDisabled);
      else if (st === 'upcoming') this.show('info', this.dataset.msgUpcoming);
      else if (st === 'closed') this.show('info', this.dataset.msgClosed);
      else if (this.msg && this.msg.dataset.kind === 'info') this.show('', '');
    }
    show(kind, text) {
      if (!this.msg) return;
      this.msg.dataset.kind = kind || '';
      this.msg.textContent = text || '';
      this.msg.hidden = !text;
      this.msg.className = 'vvs-msg' + (kind ? ' vvs-msg--' + kind : '');
    }
    fieldError(name, text) {
      var input = this.form.elements[name];
      var err = this.form.querySelector('[data-err-for="' + name + '"]');
      if (input) { input.setAttribute('aria-invalid', text ? 'true' : 'false'); }
      if (err) { err.textContent = text || ''; err.hidden = !text; }
    }
    validate() {
      var f = this.form.elements, ok = true, first = null, self = this;
      function chk(name, test, text) {
        var el = f[name]; if (!el) return;
        var good = test(el); self.fieldError(name, good ? '' : text);
        if (!good) { ok = false; first = first || el; }
      }
      chk('name', function (el) { return el.value.trim().length >= 2; }, 'Escribe tu nombre.');
      chk('email', function (el) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(el.value.trim()); }, 'Escribe el email con el que hiciste el pedido.');
      chk('order', function (el) { return /^#?\s*\d{3,10}$/.test(el.value.trim()); }, 'Escribe el número de pedido, por ejemplo #10031.');
      if (f.facebook && f.facebook.required) chk('facebook', function (el) { return el.value.trim().length >= 2; }, 'Escribe tu nombre tal como aparece en Facebook.');
      if (f.fb_declared) chk('fb_declared', function (el) { return el.checked; }, 'Marca esta casilla para participar.');
      chk('accept_bases', function (el) { return el.checked; }, 'Debes aceptar las bases para participar.');
      if (first) first.focus();
      return ok;
    }
    submissionId() {
      var key = 'vvs:sub:' + (this.dataset.campaign || '');
      var id = null;
      try { id = sessionStorage.getItem(key); } catch (e) {}
      if (!id) {
        id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : (Date.now().toString(36) + Math.random().toString(36).slice(2));
        try { sessionStorage.setItem(key, id); } catch (e) {}
      }
      return id;
    }
    onSubmit(e) {
      e.preventDefault();
      if (this.busy) return; // doble clic
      if (!this.enabled || this.st !== 'active') { this.watch(now()); return; }
      if (!this.validate()) { this.show('err', 'Revisa los campos marcados.'); return; }
      var f = this.form.elements;
      if (f.website && f.website.value) { this.show('ok', 'Solicitud recibida.'); return; } // trampa anti-bots
      var payload = {
        campaign: this.dataset.campaign,
        submission_id: this.submissionId(),
        name: f.name.value.trim(),
        email: f.email.value.trim(),
        order: f.order.value.trim(),
        facebook: f.facebook ? f.facebook.value.trim() : '',
        fb_declared: f.fb_declared ? f.fb_declared.checked : false,
        accept_bases: f.accept_bases.checked,
        bases_version: this.dataset.basesVersion
      };
      var self = this;
      this.busy = true; this.btn.disabled = true; this.btn.setAttribute('aria-busy', 'true');
      this.show('info', 'Enviando…');
      var ctrl = ('AbortController' in window) ? new AbortController() : null;
      var to = setTimeout(function () { if (ctrl) ctrl.abort(); }, 20000);
      // text/plain = petición "simple": sin preflight CORS (necesario para Apps Script)
      fetch(this.endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload), signal: ctrl ? ctrl.signal : undefined, redirect: 'follow' })
        .then(function (r) { return r.json(); })
        .then(function (res) { self.result(res || {}); })
        .catch(function () { self.show('err', self.dataset.msgNetwork); })
        .then(function () { clearTimeout(to); self.busy = false; self.btn.removeAttribute('aria-busy'); if (self.st === 'active' && !self.done) self.btn.disabled = false; });
    }
    result(res) {
      var s = res.status;
      var m = {
        received: this.dataset.msgReceived,
        duplicate: this.dataset.msgDuplicate,
        closed: this.dataset.msgClosed,
        not_started: this.dataset.msgUpcoming,
        rate_limited: 'Has hecho demasiados intentos. Espera unos minutos y vuelve a probar.',
        invalid: 'Revisa los datos: ' + ((res.fields || []).map(function (x) { return x; }).join(', ') || 'formulario incompleto') + '.'
      }[s];
      if (s === 'received' || s === 'duplicate') {
        this.done = true;
        try { sessionStorage.removeItem('vvs:sub:' + (this.dataset.campaign || '')); } catch (e) {}
        this.show('ok', m + (res.ref ? ' Referencia: ' + res.ref + '.' : ''));
        Array.prototype.forEach.call(this.form.elements, function (el) { if (el.type !== 'hidden') el.disabled = true; });
        return;
      }
      if (s === 'closed') { this.end = Math.min(this.end || Infinity, now()); }
      this.show('err', m || this.dataset.msgNetwork);
    }
  }
  if (!customElements.get('vv-sorteo-form')) customElements.define('vv-sorteo-form', VVSorteoForm);

  /* Paso 2: el clic solo indica "enlace abierto", NUNCA seguimiento verificado. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-vvs-fb]');
    if (!a) return;
    var step = a.closest('[data-vvs-step]');
    if (step) step.setAttribute('data-opened', 'true');
    try { localStorage.setItem('vvs:fb-opened', '1'); } catch (err) {}
  });
  document.addEventListener('DOMContentLoaded', function () {
    var opened = false; try { opened = localStorage.getItem('vvs:fb-opened') === '1'; } catch (e) {}
    if (opened) document.querySelectorAll('[data-vvs-step="facebook"]').forEach(function (s) { s.setAttribute('data-opened', 'true'); });
  });

  window.VVHW = { now: now, state: state, madridDay: madridDay, sync: syncServerTime, _subs: subscribers };
  syncServerTime();
})();
